import type React from 'react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { QuestionAnswerItem } from '@/components/QuestionAnswerItem';
import { ThemeMode } from '@/helpers/enums';

import { ScFaq } from './styled';

interface FaqProps {
  ns: string;
  translationKey: string;
  translationValues?: Object;
  mode?: ThemeMode;
  itemClassName?: string;
}

export const Faq: React.FC<FaqProps> = ({
  ns,
  translationKey,
  translationValues,
  itemClassName,
  mode = ThemeMode.Light,
}) => {
  const { t } = useTranslation(ns);

  const [openAnswer, setOpenAnswer] = useState<number>(-1);

  const handleSelectQuestion = (index: number) => () => {
    setOpenAnswer((prev) => (index === prev ? -1 : index));
  };

  const faqData = useMemo(
    () =>
      Object.values(
        t(translationKey, { returnObjects: true, ...translationValues }) as {
          question: string;
          answer: string;
        }[]
      ),
    [t, translationKey, translationValues]
  );

  return (
    <ScFaq>
      {faqData.map(({ question, answer }, index) => (
        <QuestionAnswerItem
          className={itemClassName}
          description={answer}
          handleOpen={handleSelectQuestion(index)}
          isOpen={index === openAnswer}
          key={index}
          mode={mode}
          title={question}
        />
      ))}
    </ScFaq>
  );
};
